import React from "react";
import withStyles from "react-jss";
import { FromFade } from "ComponentsUI/Animations";

const successTextStyle = (theme) => ({
	root: {
		width: "100%",
		textAlign: "center",
	},
	header: {
		color: "white",
		fontFamily: "MuseoSansCyrl-700",
		fontSize: "18px",
		lineHeight: "1.11",
		textAlign: "center",
		width: "500px",
		margin: "0 auto",
		marginBottom: "10px",
	},
	"@media (min-width: 765px)": {
		root: {
			margin: "0 auto",
			padding: "0",
			maxWidth: "710px",
		},
	},
	"@media (min-width: 1200px)": {
		root: {
			maxWidth: "940px",
		},
	},
	"@media (max-width: 1200px) and (min-width: 765px)": {
		root: {
			padding: "0",
		},
		header: {
			fontFamily: "MuseoSansCyrl-700",
			fontSize: "18px",
			lineHeight: "1.11",
			textAlign: "center",
			width: "100%",
			padding: "0 60px",
			marginBottom: "10px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			padding: "0",
			width: "100%",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			flexWrap: "wrap",
			justifyContent: "flex-start",
			marginTop: "0",
			maxWidth: "280px",
			textAlign: "left",
			marginBottom: "13px",
			marginRight: "auto",
			marginLeft: "auto",
		},
		header: {
			fontFamily: "MuseoSansCyrl-700",
			fontSize: "18px",
			lineHeight: "1.11",
			textAlign: "center",
			width: "100%",
			padding: "0",
			marginBottom: "10px",
		},
	},
});

const SuccessText = withStyles(successTextStyle)(({
	children,
	classes,
	header,
	subheader,
	button,
}) => {
	return (
		<div className={classes.root}>
			<div className={classes.header}>{header}</div>
			{button}
		</div>
	);
});

export default class SuccessForm extends React.Component {
	render() {
		let text = this.props.text;
		return (
			<FromFade>
				<SuccessText header={text.NEW_WELCOME_TITLE} button={this.props.button} />
			</FromFade>
		);
	}
}
